import autobind from 'autobind-decorator';
import { computed, extendObservable, toJS } from 'mobx';
import { ObjectUtil } from '../../../../../../../common/utils/objectUtil';
import { _INIT_ODDS } from '../../../../../../../common/constants/sportsConstants';

@autobind
class MatchOddsInternationalsModel {
  constructor(data) {
    extendObservable(this, data);
  }

  filterOdds(type, arr) {
    return arr.filter((item) => item.type === type)[0];
  }

  preOddsCheck(filterData) {
    let result = null;

    if (filterData.preOdds) {
      if (filterData.odds > filterData.preOdds) {
        result = 'up';
      } else if (filterData.odds < filterData.preOdds) {
        result = 'down';
      }
    }

    return result;
  }

  setOdds(type, arr) {
    let result = { value: '-', isChange: null, id: null };
    const filterData = this.filterOdds(type, arr);

    if (!!filterData) {
      result.value = filterData.odds.toFixed(2);
      result.isChange = this.preOddsCheck(filterData);
      result.id = filterData.id;
    }

    return result;
  }

  @computed
  get getOdds() {
    const { oddsList } = this;
    const { handicapOdds, underOverOdds, winLoseOdds } = oddsList;

    let result = ObjectUtil.deepClone(_INIT_ODDS);

    if (handicapOdds.length > 0) {
      result.handicapOdds.win = this.setOdds('HANDICAP_WIN', handicapOdds);
      result.handicapOdds.draw = this.setOdds('HANDICAP_DRAW', handicapOdds);
      result.handicapOdds.loss = this.setOdds('HANDICAP_LOSS', handicapOdds);
      result.handicapOdds.option = `${
        handicapOdds.filter((item) => item.type === 'HANDICAP_WIN')[0]
          .optionValue
      }`;
    }

    if (underOverOdds.length > 0) {
      result.underOverOdds.win = this.setOdds('UNDER', underOverOdds);
      result.underOverOdds.loss = this.setOdds('OVER', underOverOdds);
      result.underOverOdds.option = `${
        underOverOdds.filter((item) => item.type === 'UNDER')[0].optionValue
      }`;
    }

    if (winLoseOdds.length > 0) {
      result.winLoseOdds.win = this.setOdds('WIN', winLoseOdds);
      result.winLoseOdds.draw = this.setOdds('DRAW', winLoseOdds);
      result.winLoseOdds.loss = this.setOdds('LOSS', winLoseOdds);
    }

    return result;
  }
}

export default MatchOddsInternationalsModel;
